import styled from "styled-components";

export const StyledGalleryContainer = styled.div`
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    gap: 12px;
    width: 100%;
`;

export const StyledImageWrapper = styled.div<{ $selected: boolean }>`
    position: relative;
    border-radius: 8px;
    overflow: hidden;
    cursor: pointer;
    transition: all 0.2s ease;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.12);
    aspect-ratio: 1 / 1;

    outline: ${({ $selected }) =>
        $selected ? "3px solid #3A57E8" : "3px solid transparent"};
    outline-offset: 2px;

    &:hover {
        box-shadow: 0 4px 16px rgba(58, 87, 232, 0.25);
        transform: scale(1.02);
    }

    img {
        width: 100%;
        height: 100%;
        object-fit: cover;
    }
`;
